export default __webpack_public_path__ + "static/media/info-preservation-zones.dde560b6.svg";